// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-section div {
  height: 97% !important;
}

.search-box-textfield {
  position: "relative";
  display: "flex";
  flex: 0 0 19%;
  margin-right: 0px;
}

.search-box-textfield, .search-box-datefield {
  margin: 0 10px 0 0px;
}

@media (max-width: 768px) {
  .search-box-textfield, .search-box-datefield {
    display: "flex";
    flex: 0 0 100% !important;
    margin: 0px 0px 10px 0px;
  }
  .MuiTextField-root {
    margin: 0px !important;
  }
  span.last-updated-time {
    align-self: auto !important;
    margin: 0px 0px 10px 0px;
  }
}
@media (min-width: 1266px) {
  form {
    justify-content: end;
  }
}
@media (min-width: 1024px) and (max-width: 1266px) {
  form {
    justify-content: flex-start;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .search-box-textfield, .search-box-datefield {
    display: "flex";
    flex: 0 0 100% !important;
    margin: 0px;
  }
  span.last-updated-time {
    align-self: auto !important;
  }
}
.search-box-datefield {
  display: "flex";
  flex: 0 0 19%;
  align-self: center;
}

.last-updated-time {
  font-size: 12px;
  align-self: center;
}`, "",{"version":3,"sources":["webpack://./src/features/reminder-list/reminder-list.scss"],"names":[],"mappings":"AAOG;EACI,sBAAA;AANP;;AASA;EACG,oBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AANH;;AAQA;EACG,oBAAA;AALH;;AAQA;EACG;IACG,eAAA;IACA,yBAAA;IACA,wBAAA;EALJ;EAOC;IACG,sBAAA;EALJ;EAOC;IACG,2BAAA;IACA,wBAAA;EALJ;AACF;AAOA;EACG;IACG,oBAAA;EALJ;AACF;AAOA;EACG;IACG,2BAAA;EALJ;AACF;AAOA;EACG;IAEG,eAAA;IACA,yBAAA;IACA,WAAA;EANJ;EASC;IACG,2BAAA;EAPJ;AACF;AASA;EAEG,eAAA;EACA,aAAA;EACA,kBAAA;AARH;;AAmBA;EACG,eAAA;EACA,kBAAA;AAhBH","sourcesContent":["// .leftSearchFormDiv{\n//     // position: \"relative\";\n//    display: \"flex\";\n//    flex: 0 0 50%;  \n// }\n\n.pdf-section {\n   div {\n       height: 97% !important;\n   }\n}\n.search-box-textfield{\n   position: \"relative\";\n   display: \"flex\";\n   flex: 0 0 19%;  \n   margin-right: 0px;\n}\n.search-box-textfield,.search-box-datefield{\n   margin: 0 10px 0 0px;\n}\n\n@media (max-width: 768px) {\n   .search-box-textfield,.search-box-datefield{\n      display: \"flex\";\n      flex: 0 0 100% !important; \n      margin:0px 0px 10px  0px;\n   }\n   .MuiTextField-root {\n      margin: 0px !important;\n   }\n   span.last-updated-time{\n      align-self: auto !important;\n      margin: 0px 0px 10px 0px\n   };\n}\n@media (min-width: 1266px) {\n   form{\n      justify-content: end;\n   }\n}\n@media (min-width:1024px) and (max-width: 1266px) {\n   form{\n      justify-content: flex-start;\n   }\n}\n@media (min-width:768px) and (max-width: 1024px) {\n   .search-box-textfield,.search-box-datefield{\n      // position: \"relative\";\n      display: \"flex\";\n      flex: 0 0 100% !important; \n      margin:0px \n      // margin-right: 10px;\n   }\n   span.last-updated-time{\n      align-self: auto !important;\n   }\n}\n.search-box-datefield{\n   // position: \"relative\";\n   display: \"flex\";\n   flex: 0 0 19%;  \n   align-self: center;\n}\n// .searchForm{\n//     display: flex;\n//     // flex: 0 0 50%;  \n// }\n// .searchForm1{\n//     display: flex;\n   \n// }\n\n.last-updated-time{\n   font-size: 12px;\n   align-self: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
